module.exports = __webpack_public_path__ + "static/media/toc-mockup-4.964cdb57.jpg";